import { collection, query, where, getDocs } from 'firebase/firestore'
import { fs, fbStorage } from '../Services/firebase'

export function getBusiness() {
  return new Promise((resolve, reject) => {
    fs.collection('business')
      .get()
      .then(querySnapshot => {
        let business = [];
        querySnapshot.forEach(doc => {                  
          business.push(doc.data())
        })
        resolve(business);
      })

  })
}

export function addBusiness(businessData) {
  return new Promise((resolve, reject) => {
    let bizRef = fs.collection("business").doc();
    businessData.businessId = bizRef.id
    bizRef.set(businessData);
    resolve(businessData);
  })
}

export function editBusiness(businessData) {
  return new Promise((resolve, reject) => {
    let bizRef = fs.collection("business").doc(businessData.businessId);
    return bizRef.update(businessData)
      .then(() => {
        resolve('ok');
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
      });

  })
}

export function deleteBusiness(id) {
  return new Promise((resolve, reject) => {
    fs.collection("business").doc(id).delete().then(() => {
      resolve('ok');
    }).catch((error) => {
      console.error("Error removing document: ", error);
    });

  })
}

export function uploadBusinessImage(file) {
  return new Promise((resolve, reject) => {
    const storageRef = fbStorage.ref('businessImages');
    const imageRef = storageRef.child(file.name);
    imageRef.put(file)
      .then(() => {
        fbStorage.ref('businessImages').child(file.name).getDownloadURL().then(url => {
          resolve(url);
          // alert("Image uploaded successfully to Firebase.");
        })
      });

  })
}